'use client'

import { ReactNode } from 'react'

import ErrorBoundary from './error-boundary'
import ErrorUi from './error-ui'

const AppErrorBoundary = ({
  children,
  reset,
}: {
  readonly children: ReactNode
  reset?: { label?: string; action?: () => void }
}) => (
  <ErrorBoundary fallback={(error) => <ErrorUi reset={reset} error={error} />}>
    {children}
  </ErrorBoundary>
)

export default AppErrorBoundary
